import { useFromScreens } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import * as React from 'react';
import { NavbarLandingDesktop } from './NavbarLandingDesktop';
import { NavbarLandingMobile } from './NavbarLandingMobile';

export const NavbarLanding = (props) => {
  const [, from1280] = useFromScreens([0, 1280]);

  if (from1280) {
    return <NavbarLandingDesktop {...props} />;
  }

  return <NavbarLandingMobile {...props} />;
};
